export default "__VITE_ASSET__CGU90Ff2__"